(function (window, angular, undefined) {
	angular.module('formApp')
		.service('updateHeader', function () {
			var header;
			if (sessionStorage.getItem('eQuote')) {
				header = sessionStorage.getItem('pet');
			}
			else {
				header = 'default';
			}
			return {
				// Set the initial value of dog. This value will then br updated in the step one controller via the pet selecter component       
				petType: header
			};
		});
})(window, window.angular);